import { render } from "./VerSucursales.vue?vue&type=template&id=a1d99a28&scoped=true"
import script from "./VerSucursales.vue?vue&type=script&lang=js"
export * from "./VerSucursales.vue?vue&type=script&lang=js"

import "./VerSucursales.vue?vue&type=style&index=0&id=a1d99a28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d99a28"]])

export default __exports__